import { render, staticRenderFns } from "./Hall.vue?vue&type=template&id=357c0811&scoped=true"
import script from "./Hall.vue?vue&type=script&lang=js"
export * from "./Hall.vue?vue&type=script&lang=js"
import style0 from "./Hall.vue?vue&type=style&index=0&id=357c0811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357c0811",
  null
  
)

export default component.exports